import { Controller } from "@hotwired/stimulus"

// The Business tools on /tools (tools/index): on a phone each step starts folded under its name, so 33 cards
// aren't one long column. Wider, every step stays open and its name is only a label: not pressed, not tabbed to.
// Without JavaScript they're all open.
export default class extends Controller {
  static targets = ["step"]

  connect() {
    this.phone = window.matchMedia("(max-width: 39.99rem)")
    this.fit = () => this.stepTargets.forEach((step) => {
      // A tool page's breadcrumb lands on its step (#shelf-<key>), open.
      step.open = !this.phone.matches || (location.hash !== "" && step.parentElement.id === location.hash.slice(1))
      step.querySelector("summary").tabIndex = this.phone.matches ? 0 : -1
    })
    this.fit()
    this.phone.addEventListener("change", this.fit)
  }

  disconnect() {
    this.phone.removeEventListener("change", this.fit)
  }

  // A step's name pressed wider than a phone keeps it open.
  hold(event) {
    if (!this.phone.matches && event.target.closest("summary")) event.preventDefault()
  }
}
